<!-- Translated: yes -->
<template>
  <div :class="fullsize ? 'isfullsize' : 'normal' + ' slideshow-wrapper'">
    <agile
        :options="options1"
        ref="main"
        class="main-slideshow"
        @beforeChange="syncThumbnails($event)"
        v-if="showNow || !fullsize"
    >
      <div class="slide" v-for="(image, index) in images" v-bind:key="index"  @click="openFullSlideShow(index)">
        <div class="blur">
        </div>
        <div class="image" :style="'background-image:url(' + image.path_corrected + ')'">
        </div>
      </div>
      <template slot="prevButton"> <img src="https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg" /></template>
      <template slot="nextButton"> <img src="https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-right.svg" /></template>
    </agile>
    <agile
        :options="options2"
        ref="thumbnails"
        class="thumbnails"
        v-if="showNow || !fullsize"
    >
      <div class="slide thumbnail" v-for="(image, index) in images" v-bind:key="index" @click="$refs.main.goTo(index)">
        <div class="image" :style="'background-image:url(' + image.path_corrected + ')'">
        </div>
      </div>
      <template slot="prevButton"> <img src="https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg" /></template>
      <template slot="nextButton"> <img src="https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-right.svg" /></template>
    </agile>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import SlideshowNested from '@/components/components/Slideshow';

export default {
  props: ['images', 'fullsize', 'image'],
  components: {
    Modal,
    SlideshowNested,
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    openFullSlideShow(index) {
      this.openModal(['SlideshowModal', {
        images: this.images,
        image: index,
      }]);
    },
    syncThumbnails(event) {
      this.$refs.thumbnails.goTo(event.nextSlide);
    },
  },
  data() {
    return {
      asNavFor1: [],
      asNavFor2: [],
      options1: {
        speed: 200,
        timing: 'linear',
        slidesToShow: 1,
      },
      options2: {
        autoplay: false,
        slidesToShow: this.fullsize ? 3 : 3,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: this.fullsize ? 6 : 4,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: this.fullsize ? 8 : 4,
            },
          },
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: this.fullsize ? 10 : 4,
            },
          },
        ],
      },
      modalIsOpen: false,
      showNow: false,
    };
  },
  mounted() {
    this.asNavFor1.push(this.$refs.thumbnails);
    this.asNavFor2.push(this.$refs.main);

    if (this.fullsize) {
      const $this = this;

      setTimeout(() => {
        $this.showNow = true;

        setTimeout(() => {
          $this.$refs.main.goTo(this.image);
        }, 100);
      }, 100);
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.slide
  // background-color greyish-brown
  position relative
  cursor: pointer
  .image,.blur
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute
  .image
    // background-size: cover;
  .blur
    position absolute
    top 0
    left 0
    background-size cover
    opacity 0.4
    filter: blur(20px);

.normal .slide
  height 480px !important
  padding 10px 10px 100px 10px
  @media(max-width: 1530px)
    height 450px !important
  @media(max-width: 1024px)
    height 59vw !important
  @media(max-width: 768px)
    height 79vw !important
  @media(max-width: 650px)
    height 90vw !important
  .image,.blur
    height calc(480px - 120px) !important
    width calc(100% - 20px) !important;
    @media(max-width: 1530px)
      height calc(450px - 120px) !important
    @media(max-width: 1024px)
      height calc(59vw - 120px) !important
    @media(max-width: 768px)
      height calc(79vw - 120px) !important
    @media(max-width: 650px)
      height calc(90vw - 120px) !important
  .blur
    height 480px !important
    width 100% !important;
    @media(max-width: 1530px)
      height 450px !important
    @media(max-width: 1024px)
      height 59vw !important
    @media(max-width: 768px)
      height 79vw !important
    @media(max-width: 650px)
      height 90vw !important

.normal .thumbnails
  height: 100px !important;
  margin-top -115px
  .slide.thumbnail
    height: 80px !important
    margin-top: 10px !important
    &.agile__slide--active
      scale 1.2
    .image
      height: 80px !important
      max-height: 80px !important
      background-position: center

.isfullsize .slide
  cursor: default
  &.thumbnail
    cursor pointer

.isfullsize .slide
  height 80vh !important
  padding 10px 10px 100px 10px
  +max-tablet()
    height 80vh !important
  +max-mobile()
    height 80vh !important
  .image,.blur
    height calc(80vh - 120px) !important
    width calc(100% - 20px) !important;
    +max-tablet()
      height calc(80vh - 120px) !important
    +max-mobile()
      height calc(80vh - 120px) !important
  .blur
    height 80vh !important
    width 100% !important;
    +max-tablet()
      height 80vh !important
    +max-mobile()
      height 80vh !important

.isfullsize .thumbnails
  height: 100px !important;
  margin-top -120px
  .slide.thumbnail
    height: 80px !important
    margin-top: 10px !important
    &.agile__slide--active
      scale 1.2
    .image
      height: 80px !important
      max-height: 80px !important

</style>

<style>
/* .agile__actions {
    position: absolute;
    top: 50%;
    display: flex;
    justify-content: space-between;
    width: 100%;
    transform: translate(0, -50%);
} */

.main-slideshow .agile__actions img {
  height: 31px;
}

.main-slideshow .agile__nav-button--prev,
.main-slideshow .agile__nav-button--next {
  position: absolute;
  top: calc(50% - 16px - 7px - 50px);
  left: 0;
}

.main-slideshow .agile__nav-button--next {
  left: auto;
  right: 0;
}

.main-slideshow .agile__nav-button--prev,
.main-slideshow .agile__nav-button--next,
.main-slideshow .agile__nav-button--prev:hover,
.main-slideshow .agile__nav-button--next:hover {
  background: transparent;
  border: 0;
}

.thumbnails {
  padding-left: 25px;
  padding-right: 25px;
}

.thumbnails .agile__actions img {
  height: 20px;
}

.thumbnails .agile__nav-button--prev,
.thumbnails .agile__nav-button--next {
  position: absolute;
  top: calc(50% - 16px);
  left: 0;
  padding-left: 7px;
  padding-right: 7px;
}

.thumbnails .agile__nav-button--next {
  left: auto;
  right: 0;
}

.thumbnails .agile__nav-button--prev,
.thumbnails .agile__nav-button--next,
.thumbnails .agile__nav-button--prev:hover,
.thumbnails .agile__nav-button--next:hover {
  background: transparent;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// Slideshow.vue?39b19c71